export default __webpack_public_path__ + "static/overlay-141703a68ddee5526d1553efe92968c5.png";